import { useSelector } from 'react-redux';

import {
  getRepositoryAccessLevel,
  getRepositoryDetails,
} from 'src/selectors/repository-selectors';

export const useRepositoryAdminStatus = () => {
  const repositoryAccessLevel = useSelector(getRepositoryAccessLevel);
  const repositoryDetails = useSelector(getRepositoryDetails);

  const isLoaded = repositoryDetails?.isLoading === false;
  const isAdmin = isLoaded && repositoryAccessLevel === 'admin';

  return isAdmin;
};
